import React, { useContext, useEffect, useState } from "react";
import TextInput from "../Field_Component/TextInput";
import ButtonInput from "../Button_Components/ButtonInput";
import { Card } from "@mui/material";
import OTPAuthContext from "../../Context/OTPAuthContext";
import DataProvider from "../../Context/DataProvider";

function Login() {
  const {
    handleOTP,
    errors,
    getOTP,
    otpFieldVisible,
    otp,
    handleOtpValidate,
    onSendOtp,
    mobNumber,
    timeLeft,
    setTimeLeft,
    canResend,
    setCanResend,
    otpGettingLoad
  } = useContext(OTPAuthContext);



  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup timer on component unmount
    } else {
      setCanResend(true); // Enable OTP resend when timer reaches 0
    }
  }, [timeLeft]);

  // Convert seconds to minutes and seconds
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds
    }`;
  };

  const handleResend = () => {
    if (canResend) {
      // Logic to resend OTP
      onSendOtp(); // Call the resend OTP logic passed as a prop
      console.log("Resending OTP...");
      setTimeLeft(300); // Reset countdown to 5 minutes
      setCanResend(false); // Disable resend until countdown finishes
    }
  };

  return (
    <>
      <Card sx={{ width: "300px", margin: "20vh auto", padding: "16px" }}>
        <TextInput
          required
          style={{ margin: "12px 0" }}
          title="Mobile No."
          type="Number"
          handleFunction={handleOTP}
          error={errors?.error}
          helper_text={errors.errorText}
        />

        {otpFieldVisible && (
          <TextInput
            required
            title="OTP"
            handleFunction={getOTP}
            type="Number"
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row-reverse",
          }}
        >
          {!otpFieldVisible ? (
            <ButtonInput
              title={"Get OTP"}
              side="end"
              loading={otpGettingLoad}
              onClick={onSendOtp}
              disabled={mobNumber?.length !== 10}
            />
          ) : (
            <ButtonInput
              title={"Submit"}
              side="end"
              loading={otpGettingLoad}
              onClick={handleOtpValidate}
              disabled={otp?.length !== 6 || canResend}
            />
          )}
          <div
            style={{ padding: "12px 0", textAlign: "center", fontSize: "14px" }}
          >
            {otpFieldVisible && (
              <span
                role="button"
                onClick={handleResend}
                style={{
                  cursor: canResend ? "pointer" : "default",
                  color: canResend ? "blue" : "gray",
                  fontFamily: "sans-serif",
                }}
              >
                {!canResend ? `Resend ${formatTime(timeLeft)}` : "Resend OTP"}
              </span>
            )}
          </div>
        </div>
      </Card>
    </>
  );
}

export default Login;
